import React from 'react';

import InhouseMun2025 from '../views/InhouseMun2025';

const SchoolProgrampage = () => {
  return <InhouseMun2025 />;
};

export default SchoolProgrampage;